import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { selectIsLogged } from '../../features/auth/ducks';

export default function ProtectedRoute() {
  const isLogged = useSelector(selectIsLogged);

  if (!isLogged) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
}
